import { getField, updateField } from 'vuex-map-fields';

const user = {
  addresses: {
    employer: {
      city: '',
      line1: '',
      line2: '',
      state: '',
      zip: '',
    },
    legal: {
      city: '',
      line1: '',
      line2: '',
      state: '',
      zip: '',
    },
    mailing: {
      city: '',
      line1: '',
      line2: '',
      state: '',
      zip: '',
    },
  },
  coAffillCode: '',
  coAffillId: '',
  coAffillName: '',
  coDirectorCode: '',
  coDirectorName: '',
  coDirectorSymbol: '',
  cusip: '',
  dayPhone: '',
  dob: '',
  email: '',
  emailPreferencesEnrolled: '',
  employerAddressSameAsLegal: '',
  employersName: '',
  employmentStatus: '',
  firstName: '',
  middleName: '',
  lastName: '',
  mailingSameAsLegal: '',
  mailingSendDuplicateToAddress: '',
  occupation: '',
  receiveAccountDocElectronically: '',
  mobilePhoneCheckIndicator: true,
  residenceCountry: '',
  ssn: '',
  taxCountry: '',
  usCitizen: '',
  viewpointsEnrollment: '',
  reviewAndConfirmHTML: '',
  agreeTermsHTML: '',
  taxWithHolding: false,
  existingCustomer: '',
  cashPosition: '',
  additionalDetails: {},
  gNumber: '',
};
const primaryUserData = JSON.parse(JSON.stringify(user));
primaryUserData.customerAgreement = false;

export default {
  name: 'formData',
  namespaced: true,
  state: {
    additionalUsers: [],
    accountDetails: {},
    primaryUser: primaryUserData,
    secondaryUser: JSON.parse(JSON.stringify(user)),
  },
  getters: {
    getField,
    formData: (state) => state,
  },
  mutations: {
    updateField,
    resetData: (state) => {
      Object.keys(state).forEach((e) => {
        state[e] = null;
      });
    },
  },
};
